'use client';

import { Libraries, useLoadScript } from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import { defaultLibraries } from '../../../../../utils/google-maps-types';

export function MapProvider({ children }: { children: React.ReactNode }) {
  const [scriptError, setScriptError] = useState<Error | null>(null);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY!,
    libraries: defaultLibraries as unknown as Libraries,
    version: 'weekly',
    language: 'en',
    region: 'BE',
  });

  useEffect(() => {
    if (loadError) {
      setScriptError(loadError);
      console.error('Google Maps script loading error:', loadError);
    }
  }, [loadError]);

  if (!isLoaded) {
    return null;
  }
  
  return <>{children}</>;
} 